import type { ApInvoicePurchaseKind } from "./apInvoicesApi";

const LABELS: Record<ApInvoicePurchaseKind, string> = {
  po_inventory: "PO / inventory",
  non_po_purchase: "Non-PO purchase",
  standalone_tsh: "Standalone TSH",
};

export function apInvoicePurchaseKindLabel(kind: ApInvoicePurchaseKind): string {
  return LABELS[kind];
}
